import apiClient from "./apiClient";

// Create user
export const createUser = async (payload) => {
    try {
        const response = await apiClient.post("/admin/user/create", payload, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        

        return response.data;
    } catch (error) {
        console.error("Error creating user:", error);
        throw error;
    }
};

// Get users
export const getUser = async () => {
    try {
        const response = await apiClient.get("/admin/user", {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error getting users:", error);
        throw error;
    }
};

// Update users
export const updateUser = async (id, payload) => {
    try {
        const response = await apiClient.put(`/admin/user/${id}`, payload, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error deleting users:", error);
        throw error;
    }
};

// Delete users
export const deleteUser = async (id) => {
    try {
        const response = await apiClient.delete(`/admin/user/${id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error deleting users:", error);
        throw error;
    }
};

export const getRoles = async () => {
    try {
        const response = await apiClient.get("/admin/roles", {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error getting roles:", error);
        throw error;
    }
};
